import React from 'react';
import EmailAddressBookContainer from './EmailAddressBookContainer';

const EmailAddressBook = (props) => (
  <EmailAddressBookContainer {...props} />
);

export default EmailAddressBook;



// WEBPACK FOOTER //
// src/routes/EmailAddressBook/index.js